export class revenueDetailsByCategoryReq{
	date :  string;
	divisionId : number;
	clientCode : string;
	isMain : number;
	categoryId : number
}